import { render, staticRenderFns } from "./MultipleObjectAutocomplete.vue?vue&type=template&id=494b4138&scoped=true&"
import script from "./MultipleObjectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./MultipleObjectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b4138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VRow})
